export default __webpack_public_path__ + "static/media/pen.4152d269.svg";